<script setup>
import AchievementsSidebar from "@components/achievements/Sidebar.vue";
</script>

<template>
    <div class="contents">
        <AchievementsSidebar />
    </div>
</template>
